// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as IndexRouteImport } from './routes/index'
import { Route as AboutRouteImport } from './routes/about'
import { Route as AccessibilityRouteImport } from './routes/accessibility'
import { Route as BusinessEmailRouteImport } from './routes/business-email'
import { Route as ContactRouteImport } from './routes/contact'
import { Route as CookiesRouteImport } from './routes/cookies'
import { Route as FaqRouteImport } from './routes/faq'
import { Route as MeetingRouteImport } from './routes/meeting'
import { Route as PrivacyRouteImport } from './routes/privacy'
import { Route as ProjectsRouteImport } from './routes/projects'
import { Route as QuoteRouteImport } from './routes/quote'
import { Route as ReviewOurWorkRouteImport } from './routes/review-our-work'
import { Route as SitegroundHostingRouteImport } from './routes/siteground-hosting'
import { Route as TermsRouteImport } from './routes/terms'
import { Route as ServicesIndexRouteImport } from './routes/services/index'
import { Route as ServicesMaintenanceRouteImport } from './routes/services/maintenance'
import { Route as ThankYouContactRouteImport } from './routes/thank-you/contact'
import { Route as ThankYouMeetingRouteImport } from './routes/thank-you/meeting'
import { Route as ThankYouQuoteRouteImport } from './routes/thank-you/quote'
import { Route as ThankYouReviewRouteImport } from './routes/thank-you/review'
import { Route as ToolsIndexRouteImport } from './routes/tools/index'
import { Route as ToolsBundleAnalyzerRouteImport } from './routes/tools/bundle-analyzer'
import { Route as ToolsCodeExplainerRouteImport } from './routes/tools/code-explainer'
import { Route as ToolsCodeFormatterRouteImport } from './routes/tools/code-formatter'
import { Route as ToolsColorPaletteGeneratorRouteImport } from './routes/tools/color-palette-generator'
import { Route as ToolsCoreWebVitalsRouteImport } from './routes/tools/core-web-vitals'
import { Route as ToolsCronBuilderRouteImport } from './routes/tools/cron-builder'
import { Route as ToolsCssGeneratorRouteImport } from './routes/tools/css-generator'
import { Route as ToolsCurlConverterRouteImport } from './routes/tools/curl-converter'
import { Route as ToolsDiffCheckerRouteImport } from './routes/tools/diff-checker'
import { Route as ToolsDockerfileLinterRouteImport } from './routes/tools/dockerfile-linter'
import { Route as ToolsEncoderDecoderRouteImport } from './routes/tools/encoder-decoder'
import { Route as ToolsEnvFormatterRouteImport } from './routes/tools/env-formatter'
import { Route as ToolsFakeApiGeneratorRouteImport } from './routes/tools/fake-api-generator'
import { Route as ToolsFaviconGeneratorRouteImport } from './routes/tools/favicon-generator'
import { Route as ToolsGraphqlExplorerRouteImport } from './routes/tools/graphql-explorer'
import { Route as ToolsHashGeneratorRouteImport } from './routes/tools/hash-generator'
import { Route as ToolsHmacGeneratorRouteImport } from './routes/tools/hmac-generator'
import { Route as ToolsHttpRequestBuilderRouteImport } from './routes/tools/http-request-builder'
import { Route as ToolsImageOptimizerRouteImport } from './routes/tools/image-optimizer'
import { Route as ToolsIpInspectorRouteImport } from './routes/tools/ip-inspector'
import { Route as ToolsJsonFormatterRouteImport } from './routes/tools/json-formatter'
import { Route as ToolsJwtDebuggerRouteImport } from './routes/tools/jwt-debugger'
import { Route as ToolsJwtDecoderRouteImport } from './routes/tools/jwt-decoder'
import { Route as ToolsLighthouseAuditRouteImport } from './routes/tools/lighthouse-audit'
import { Route as ToolsMarkdownPreviewRouteImport } from './routes/tools/markdown-preview'
import { Route as ToolsNetworkToolkitRouteImport } from './routes/tools/network-toolkit'
import { Route as ToolsPasswordGeneratorRouteImport } from './routes/tools/password-generator'
import { Route as ToolsPasswordStrengthTesterRouteImport } from './routes/tools/password-strength-tester'
import { Route as ToolsRegexGeneratorRouteImport } from './routes/tools/regex-generator'
import { Route as ToolsRegexTesterRouteImport } from './routes/tools/regex-tester'
import { Route as ToolsSeoAnalyzerRouteImport } from './routes/tools/seo-analyzer'
import { Route as ToolsSeoMetaGeneratorRouteImport } from './routes/tools/seo-meta-generator'
import { Route as ToolsSqlBuilderRouteImport } from './routes/tools/sql-builder'
import { Route as ToolsSslCheckerRouteImport } from './routes/tools/ssl-checker'
import { Route as ToolsSvgOptimizerRouteImport } from './routes/tools/svg-optimizer'
import { Route as ToolsTailwindBuilderRouteImport } from './routes/tools/tailwind-builder'
import { Route as ToolsTestDataGeneratorRouteImport } from './routes/tools/test-data-generator'
import { Route as ToolsTimestampConverterRouteImport } from './routes/tools/timestamp-converter'
import { Route as ToolsUuidGeneratorRouteImport } from './routes/tools/uuid-generator'
import { Route as ToolsSecureNoteIndexRouteImport } from './routes/tools/secure-note/index'
import { Route as ToolsSecureNoteViewIdRouteImport } from './routes/tools/secure-note/view/$id'

const IndexRoute = IndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => rootRouteImport
          })
const AboutRoute = AboutRouteImport.update({
            id: '/about',path: '/about',getParentRoute: () => rootRouteImport
          })
const AccessibilityRoute = AccessibilityRouteImport.update({
            id: '/accessibility',path: '/accessibility',getParentRoute: () => rootRouteImport
          })
const BusinessEmailRoute = BusinessEmailRouteImport.update({
            id: '/business-email',path: '/business-email',getParentRoute: () => rootRouteImport
          })
const ContactRoute = ContactRouteImport.update({
            id: '/contact',path: '/contact',getParentRoute: () => rootRouteImport
          })
const CookiesRoute = CookiesRouteImport.update({
            id: '/cookies',path: '/cookies',getParentRoute: () => rootRouteImport
          })
const FaqRoute = FaqRouteImport.update({
            id: '/faq',path: '/faq',getParentRoute: () => rootRouteImport
          })
const MeetingRoute = MeetingRouteImport.update({
            id: '/meeting',path: '/meeting',getParentRoute: () => rootRouteImport
          })
const PrivacyRoute = PrivacyRouteImport.update({
            id: '/privacy',path: '/privacy',getParentRoute: () => rootRouteImport
          })
const ProjectsRoute = ProjectsRouteImport.update({
            id: '/projects',path: '/projects',getParentRoute: () => rootRouteImport
          })
const QuoteRoute = QuoteRouteImport.update({
            id: '/quote',path: '/quote',getParentRoute: () => rootRouteImport
          })
const ReviewOurWorkRoute = ReviewOurWorkRouteImport.update({
            id: '/review-our-work',path: '/review-our-work',getParentRoute: () => rootRouteImport
          })
const SitegroundHostingRoute = SitegroundHostingRouteImport.update({
            id: '/siteground-hosting',path: '/siteground-hosting',getParentRoute: () => rootRouteImport
          })
const TermsRoute = TermsRouteImport.update({
            id: '/terms',path: '/terms',getParentRoute: () => rootRouteImport
          })
const ServicesIndexRoute = ServicesIndexRouteImport.update({
            id: '/services/',path: '/services/',getParentRoute: () => rootRouteImport
          })
const ServicesMaintenanceRoute = ServicesMaintenanceRouteImport.update({
            id: '/services/maintenance',path: '/services/maintenance',getParentRoute: () => rootRouteImport
          })
const ThankYouContactRoute = ThankYouContactRouteImport.update({
            id: '/thank-you/contact',path: '/thank-you/contact',getParentRoute: () => rootRouteImport
          })
const ThankYouMeetingRoute = ThankYouMeetingRouteImport.update({
            id: '/thank-you/meeting',path: '/thank-you/meeting',getParentRoute: () => rootRouteImport
          })
const ThankYouQuoteRoute = ThankYouQuoteRouteImport.update({
            id: '/thank-you/quote',path: '/thank-you/quote',getParentRoute: () => rootRouteImport
          })
const ThankYouReviewRoute = ThankYouReviewRouteImport.update({
            id: '/thank-you/review',path: '/thank-you/review',getParentRoute: () => rootRouteImport
          })
const ToolsIndexRoute = ToolsIndexRouteImport.update({
            id: '/tools/',path: '/tools/',getParentRoute: () => rootRouteImport
          })
const ToolsBundleAnalyzerRoute = ToolsBundleAnalyzerRouteImport.update({
            id: '/tools/bundle-analyzer',path: '/tools/bundle-analyzer',getParentRoute: () => rootRouteImport
          })
const ToolsCodeExplainerRoute = ToolsCodeExplainerRouteImport.update({
            id: '/tools/code-explainer',path: '/tools/code-explainer',getParentRoute: () => rootRouteImport
          })
const ToolsCodeFormatterRoute = ToolsCodeFormatterRouteImport.update({
            id: '/tools/code-formatter',path: '/tools/code-formatter',getParentRoute: () => rootRouteImport
          })
const ToolsColorPaletteGeneratorRoute = ToolsColorPaletteGeneratorRouteImport.update({
            id: '/tools/color-palette-generator',path: '/tools/color-palette-generator',getParentRoute: () => rootRouteImport
          })
const ToolsCoreWebVitalsRoute = ToolsCoreWebVitalsRouteImport.update({
            id: '/tools/core-web-vitals',path: '/tools/core-web-vitals',getParentRoute: () => rootRouteImport
          })
const ToolsCronBuilderRoute = ToolsCronBuilderRouteImport.update({
            id: '/tools/cron-builder',path: '/tools/cron-builder',getParentRoute: () => rootRouteImport
          })
const ToolsCssGeneratorRoute = ToolsCssGeneratorRouteImport.update({
            id: '/tools/css-generator',path: '/tools/css-generator',getParentRoute: () => rootRouteImport
          })
const ToolsCurlConverterRoute = ToolsCurlConverterRouteImport.update({
            id: '/tools/curl-converter',path: '/tools/curl-converter',getParentRoute: () => rootRouteImport
          })
const ToolsDiffCheckerRoute = ToolsDiffCheckerRouteImport.update({
            id: '/tools/diff-checker',path: '/tools/diff-checker',getParentRoute: () => rootRouteImport
          })
const ToolsDockerfileLinterRoute = ToolsDockerfileLinterRouteImport.update({
            id: '/tools/dockerfile-linter',path: '/tools/dockerfile-linter',getParentRoute: () => rootRouteImport
          })
const ToolsEncoderDecoderRoute = ToolsEncoderDecoderRouteImport.update({
            id: '/tools/encoder-decoder',path: '/tools/encoder-decoder',getParentRoute: () => rootRouteImport
          })
const ToolsEnvFormatterRoute = ToolsEnvFormatterRouteImport.update({
            id: '/tools/env-formatter',path: '/tools/env-formatter',getParentRoute: () => rootRouteImport
          })
const ToolsFakeApiGeneratorRoute = ToolsFakeApiGeneratorRouteImport.update({
            id: '/tools/fake-api-generator',path: '/tools/fake-api-generator',getParentRoute: () => rootRouteImport
          })
const ToolsFaviconGeneratorRoute = ToolsFaviconGeneratorRouteImport.update({
            id: '/tools/favicon-generator',path: '/tools/favicon-generator',getParentRoute: () => rootRouteImport
          })
const ToolsGraphqlExplorerRoute = ToolsGraphqlExplorerRouteImport.update({
            id: '/tools/graphql-explorer',path: '/tools/graphql-explorer',getParentRoute: () => rootRouteImport
          })
const ToolsHashGeneratorRoute = ToolsHashGeneratorRouteImport.update({
            id: '/tools/hash-generator',path: '/tools/hash-generator',getParentRoute: () => rootRouteImport
          })
const ToolsHmacGeneratorRoute = ToolsHmacGeneratorRouteImport.update({
            id: '/tools/hmac-generator',path: '/tools/hmac-generator',getParentRoute: () => rootRouteImport
          })
const ToolsHttpRequestBuilderRoute = ToolsHttpRequestBuilderRouteImport.update({
            id: '/tools/http-request-builder',path: '/tools/http-request-builder',getParentRoute: () => rootRouteImport
          })
const ToolsImageOptimizerRoute = ToolsImageOptimizerRouteImport.update({
            id: '/tools/image-optimizer',path: '/tools/image-optimizer',getParentRoute: () => rootRouteImport
          })
const ToolsIpInspectorRoute = ToolsIpInspectorRouteImport.update({
            id: '/tools/ip-inspector',path: '/tools/ip-inspector',getParentRoute: () => rootRouteImport
          })
const ToolsJsonFormatterRoute = ToolsJsonFormatterRouteImport.update({
            id: '/tools/json-formatter',path: '/tools/json-formatter',getParentRoute: () => rootRouteImport
          })
const ToolsJwtDebuggerRoute = ToolsJwtDebuggerRouteImport.update({
            id: '/tools/jwt-debugger',path: '/tools/jwt-debugger',getParentRoute: () => rootRouteImport
          })
const ToolsJwtDecoderRoute = ToolsJwtDecoderRouteImport.update({
            id: '/tools/jwt-decoder',path: '/tools/jwt-decoder',getParentRoute: () => rootRouteImport
          })
const ToolsLighthouseAuditRoute = ToolsLighthouseAuditRouteImport.update({
            id: '/tools/lighthouse-audit',path: '/tools/lighthouse-audit',getParentRoute: () => rootRouteImport
          })
const ToolsMarkdownPreviewRoute = ToolsMarkdownPreviewRouteImport.update({
            id: '/tools/markdown-preview',path: '/tools/markdown-preview',getParentRoute: () => rootRouteImport
          })
const ToolsNetworkToolkitRoute = ToolsNetworkToolkitRouteImport.update({
            id: '/tools/network-toolkit',path: '/tools/network-toolkit',getParentRoute: () => rootRouteImport
          })
const ToolsPasswordGeneratorRoute = ToolsPasswordGeneratorRouteImport.update({
            id: '/tools/password-generator',path: '/tools/password-generator',getParentRoute: () => rootRouteImport
          })
const ToolsPasswordStrengthTesterRoute = ToolsPasswordStrengthTesterRouteImport.update({
            id: '/tools/password-strength-tester',path: '/tools/password-strength-tester',getParentRoute: () => rootRouteImport
          })
const ToolsRegexGeneratorRoute = ToolsRegexGeneratorRouteImport.update({
            id: '/tools/regex-generator',path: '/tools/regex-generator',getParentRoute: () => rootRouteImport
          })
const ToolsRegexTesterRoute = ToolsRegexTesterRouteImport.update({
            id: '/tools/regex-tester',path: '/tools/regex-tester',getParentRoute: () => rootRouteImport
          })
const ToolsSeoAnalyzerRoute = ToolsSeoAnalyzerRouteImport.update({
            id: '/tools/seo-analyzer',path: '/tools/seo-analyzer',getParentRoute: () => rootRouteImport
          })
const ToolsSeoMetaGeneratorRoute = ToolsSeoMetaGeneratorRouteImport.update({
            id: '/tools/seo-meta-generator',path: '/tools/seo-meta-generator',getParentRoute: () => rootRouteImport
          })
const ToolsSqlBuilderRoute = ToolsSqlBuilderRouteImport.update({
            id: '/tools/sql-builder',path: '/tools/sql-builder',getParentRoute: () => rootRouteImport
          })
const ToolsSslCheckerRoute = ToolsSslCheckerRouteImport.update({
            id: '/tools/ssl-checker',path: '/tools/ssl-checker',getParentRoute: () => rootRouteImport
          })
const ToolsSvgOptimizerRoute = ToolsSvgOptimizerRouteImport.update({
            id: '/tools/svg-optimizer',path: '/tools/svg-optimizer',getParentRoute: () => rootRouteImport
          })
const ToolsTailwindBuilderRoute = ToolsTailwindBuilderRouteImport.update({
            id: '/tools/tailwind-builder',path: '/tools/tailwind-builder',getParentRoute: () => rootRouteImport
          })
const ToolsTestDataGeneratorRoute = ToolsTestDataGeneratorRouteImport.update({
            id: '/tools/test-data-generator',path: '/tools/test-data-generator',getParentRoute: () => rootRouteImport
          })
const ToolsTimestampConverterRoute = ToolsTimestampConverterRouteImport.update({
            id: '/tools/timestamp-converter',path: '/tools/timestamp-converter',getParentRoute: () => rootRouteImport
          })
const ToolsUuidGeneratorRoute = ToolsUuidGeneratorRouteImport.update({
            id: '/tools/uuid-generator',path: '/tools/uuid-generator',getParentRoute: () => rootRouteImport
          })
const ToolsSecureNoteIndexRoute = ToolsSecureNoteIndexRouteImport.update({
            id: '/tools/secure-note/',path: '/tools/secure-note/',getParentRoute: () => rootRouteImport
          })
const ToolsSecureNoteViewIdRoute = ToolsSecureNoteViewIdRouteImport.update({
            id: '/tools/secure-note/view/$id',path: '/tools/secure-note/view/$id',getParentRoute: () => rootRouteImport
          })

const rootRouteChildren = {
  IndexRoute: IndexRoute,AboutRoute: AboutRoute,AccessibilityRoute: AccessibilityRoute,BusinessEmailRoute: BusinessEmailRoute,ContactRoute: ContactRoute,CookiesRoute: CookiesRoute,FaqRoute: FaqRoute,MeetingRoute: MeetingRoute,PrivacyRoute: PrivacyRoute,ProjectsRoute: ProjectsRoute,QuoteRoute: QuoteRoute,ReviewOurWorkRoute: ReviewOurWorkRoute,SitegroundHostingRoute: SitegroundHostingRoute,TermsRoute: TermsRoute,ServicesMaintenanceRoute: ServicesMaintenanceRoute,ThankYouContactRoute: ThankYouContactRoute,ThankYouMeetingRoute: ThankYouMeetingRoute,ThankYouQuoteRoute: ThankYouQuoteRoute,ThankYouReviewRoute: ThankYouReviewRoute,ToolsBundleAnalyzerRoute: ToolsBundleAnalyzerRoute,ToolsCodeExplainerRoute: ToolsCodeExplainerRoute,ToolsCodeFormatterRoute: ToolsCodeFormatterRoute,ToolsColorPaletteGeneratorRoute: ToolsColorPaletteGeneratorRoute,ToolsCoreWebVitalsRoute: ToolsCoreWebVitalsRoute,ToolsCronBuilderRoute: ToolsCronBuilderRoute,ToolsCssGeneratorRoute: ToolsCssGeneratorRoute,ToolsCurlConverterRoute: ToolsCurlConverterRoute,ToolsDiffCheckerRoute: ToolsDiffCheckerRoute,ToolsDockerfileLinterRoute: ToolsDockerfileLinterRoute,ToolsEncoderDecoderRoute: ToolsEncoderDecoderRoute,ToolsEnvFormatterRoute: ToolsEnvFormatterRoute,ToolsFakeApiGeneratorRoute: ToolsFakeApiGeneratorRoute,ToolsFaviconGeneratorRoute: ToolsFaviconGeneratorRoute,ToolsGraphqlExplorerRoute: ToolsGraphqlExplorerRoute,ToolsHashGeneratorRoute: ToolsHashGeneratorRoute,ToolsHmacGeneratorRoute: ToolsHmacGeneratorRoute,ToolsHttpRequestBuilderRoute: ToolsHttpRequestBuilderRoute,ToolsImageOptimizerRoute: ToolsImageOptimizerRoute,ToolsIpInspectorRoute: ToolsIpInspectorRoute,ToolsJsonFormatterRoute: ToolsJsonFormatterRoute,ToolsJwtDebuggerRoute: ToolsJwtDebuggerRoute,ToolsJwtDecoderRoute: ToolsJwtDecoderRoute,ToolsLighthouseAuditRoute: ToolsLighthouseAuditRoute,ToolsMarkdownPreviewRoute: ToolsMarkdownPreviewRoute,ToolsNetworkToolkitRoute: ToolsNetworkToolkitRoute,ToolsPasswordGeneratorRoute: ToolsPasswordGeneratorRoute,ToolsPasswordStrengthTesterRoute: ToolsPasswordStrengthTesterRoute,ToolsRegexGeneratorRoute: ToolsRegexGeneratorRoute,ToolsRegexTesterRoute: ToolsRegexTesterRoute,ToolsSeoAnalyzerRoute: ToolsSeoAnalyzerRoute,ToolsSeoMetaGeneratorRoute: ToolsSeoMetaGeneratorRoute,ToolsSqlBuilderRoute: ToolsSqlBuilderRoute,ToolsSslCheckerRoute: ToolsSslCheckerRoute,ToolsSvgOptimizerRoute: ToolsSvgOptimizerRoute,ToolsTailwindBuilderRoute: ToolsTailwindBuilderRoute,ToolsTestDataGeneratorRoute: ToolsTestDataGeneratorRoute,ToolsTimestampConverterRoute: ToolsTimestampConverterRoute,ToolsUuidGeneratorRoute: ToolsUuidGeneratorRoute,ServicesIndexRoute: ServicesIndexRoute,ToolsIndexRoute: ToolsIndexRoute,ToolsSecureNoteIndexRoute: ToolsSecureNoteIndexRoute,ToolsSecureNoteViewIdRoute: ToolsSecureNoteViewIdRoute
}
export const routeTree = rootRouteImport._addFileChildren(rootRouteChildren)